import { t } from 'i18next';

import { AssignManufacturerCell } from 'bom/elements';
import { SwitchCell } from 'core/elements';

export const getColumnDefs = (isAlternateVersionEnabled: boolean) => [
  {
    colId: 'part',
    headerName: t('headerPartNumber'),
    field: 'number',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  {
    colId: 'description',
    headerName: t('headerDescription'),
    field: 'description',
    width: 200,
    maxWidth: 400,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    cellRendererParams: {
      maxRows: 4,
    },
  },
  {
    colId: 'manufacturer',
    headerName: t('headerAssignManufacturer'),
    field: 'manufacturer',
    sortable: false,
    cellRenderer: AssignManufacturerCell,
    cellRendererParams: { isAlternateVersionEnabled },
  },
  {
    colId: 'omit',
    headerName: t('headerOmit'),
    field: 'omit',
    sortable: false,
    minWidth: 100,
    width: 100,
    maxWidth: 100,
    cellRenderer: SwitchCell,
    cellRendererParams: {
      colId: 'omit',
    },
  },
  {
    colId: 'doNotAssignManufacturer',
    headerName: t('headerDoNotAssignManufacturer'),
    field: 'doNotAssignManufacturer',
    sortable: false,
    maxWidth: 150,
    cellRenderer: SwitchCell,
    cellRendererParams: {
      colId: 'doNotAssignManufacturer',
    },
  },
];
